import { IconButton } from "@mui/material";
import { DataGrid, GridColumns, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { ArrowBackIos as ArrowBackIosIcon } from "@mui/icons-material";
import Layout from "components/Layout";
import { Colors } from "models/Colors";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import GoalController, { Goal } from "services/controllers/GoalsController";

const CustomToolbar = (props: any) => {
	const { goBackFunction } = props
	return (
		<GridToolbarContainer>
			<IconButton onClick={goBackFunction} size="large">
				<ArrowBackIosIcon style={{ color: Colors.primary }} />
			</IconButton>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport />
		</GridToolbarContainer>
	);
}

export default function Goals(props: { match: { params: { uid: string } } }) {
	const [goalsList, setGoalsList] = useState<Goal[]>([])
	const [loading, setLoading] = useState<boolean>(true)
	const history = useHistory()
	const goalController = new GoalController()
	const uid: string = props.match.params.uid


	const columns: GridColumns = [
		{ field: "id", headerName: "ID", width: 300 },
		{ field: "name", headerName: "Name", width: 200 },
		{ field: "status", headerName: "Status", width: 200 },
		{ field: "category", headerName: "Category", width: 200 },
		{ field: "type", headerName: "Type", width: 200 },
		{ field: "threshold", headerName: "Threshold", width: 200 },
		{ field: "target", headerName: "Target", width: 200 },
		{ field: "raised", headerName: "Raised", width: 200 },
	]

	const getGoals = useRef(() => { })

	useEffect(() => {
		const fetchData = () => {
			getGoals.current()
		}
		return fetchData()
	}, [])

	getGoals.current = async () => {
		goalController.getGoals(uid, (data) => {
			setGoalsList(data)
			if (loading)
				setLoading(false)
		})
	}
	return (
		<Layout id={2}>
			<div
				style={{
					height: "calc(100vh - 170px)",
					width: "100%"
				}}>
				<DataGrid
					components={{
						Toolbar: CustomToolbar,
					}}
					componentsProps={{
						toolbar: {
							goBackFunction: () => {
								history.push("/users")
							},
						}
					}}
					rows={goalsList}
					columns={columns}
					loading={loading} />
			</div>
		</Layout>
	)
}
